import React from 'react';
import SectionBrandHero from './SectionBrandHero/SectionBrandHero';
import { useListingPageContext } from '../context/ListingPageContext';

import css from '../ListingPage.module.css';

function RenderBrands() {
  const { isMobileLayout, intl, viewport } = useListingPageContext();

  return (
    <div className={css.pageRoot}>
      <SectionBrandHero isMobileLayout={isMobileLayout} intl={intl} viewport={viewport} />
    </div>
  );
}

export default RenderBrands;
